import '../styles/main.internal.scss'

import context from '../context'
import { replaceReducers } from '@/store'
context.config = require('./config')
context.menuContent = require('./menu-content').default
context.reducers = require('./reducers').default
context.widgets = require('./widgets').default
context.defaultLayout = require('@/layouts/Default').default
context.routes = require('./routes').default
context.api = require('./api').default
context.menu = require('./menu').default
context.dialogs = require('./dialogs').default
context.initializer = require('./initializer').default
context.cache = require('./cached').default

// Enable Webpack hot module replacement for reducers
if (module.hot) {
  context.replaceReducers = () => {
    context.reducers = require('./reducers').default
    replaceReducers(context.reducers)
  }
}



// WEBPACK FOOTER //
// ./src/internal-app/index.js